import script from "./SetupWizard.vue?vue&type=script&setup=true&lang=js"
export * from "./SetupWizard.vue?vue&type=script&setup=true&lang=js"

import "./SetupWizard.vue?vue&type=style&index=0&id=18a2b565&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18a2b565"]])

export default __exports__